import React, { useState, useContext, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { editarNormaContext } from '../../../pages/Normas/EditarNorma'
import "./ModalEditarNorma.scss"

function ModalEditarNorma(props) {

    const { 
        fetchTemplates,
        opc, 
        idNorma, 
        idProyectoNorma,
        user, 
        objEditar, 
        setObjEditar, 
        objTareaSub, 
        setObjTareaSub,
        fetchTareas,
        fetchSubtareas
    } = useContext(editarNormaContext)

    const [obj, setObj] = useState({
        titulo: "",
        descripcion: ""
    })

    const [errors, setErrors] = useState({})
    const [modalErr, setModalErr] = useState(null)

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(objEditar){
            const obj = JSON.parse(objEditar)
            if(opc === 1) {
                setObj({
                    titulo: obj?.nombre,
                    descripcion: obj?.detalles
                })
            } else if (opc === 2) {
                setObj({
                    titulo: obj?.nombre,
                    descripcion: obj?.descripcion
                })
            } else if (opc === 3) {
                setObj({
                    titulo: obj?.titulo,
                    descripcion: obj?.descripcion
                })
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[objEditar])

    const handleClose = () => {
        setErrors({})
        setObj({
            titulo: "",
            descripcion: ""
        })
        setObjEditar(null)
        setObjTareaSub(null)
        setModalErr(null)
        props.onHide()
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setObj({
            ...obj,
            [name]: value
        })
    }

    const validateForm = (data) => {
        const errors = {}
        if(!data.titulo.trim()){
            errors.titulo = "Escriba el título."
        }
        // if(!data.descripcion.trim()){
        //     errors.descripcion = "Escriba la descripción."
        // }
        return errors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(obj);
        setErrors(newErrors)
        const objSelec = JSON.parse(objEditar)
        let objTareaSelec = null
        if(objTareaSub) {
            objTareaSelec = JSON.parse(objTareaSub)
        }
        if(Object.keys(newErrors).length === 0){
            setModalErr(null)
            setLoading(true)
            let objEdit = null
            if(opc === 1) {
                objEdit = {
                    user,
                    id_norma: idNorma,
                    opcion: parseInt(opc),
                    objeto_modificado: {
                        tituloSubir: obj.titulo, 
                        descripcionSubir: obj.descripcion
                    }, 
                }
            } else if (opc === 2) {
                objEdit = {
                    user,
                    id_norma: idNorma,
                    opcion: parseInt(opc),
                    orden_tarea: objSelec.orden,
                    objeto_modificado: {
                        tituloSubir: obj.titulo, 
                        descripcionSubir: obj.descripcion
                    }, 
                }
            } else if (opc === 3) {
                objEdit = {
                    user,
                    id_norma: idNorma,
                    opcion: parseInt(opc),
                    orden_tarea: objTareaSelec.orden,
                    orden_subtarea: objSelec.orden,
                    objeto_modificado: {
                        tituloSubir: obj.titulo, 
                        descripcionSubir: obj.descripcion,
                        tiene_muestras: objSelec.tiene_muestras ? 1 : 0
                    }, 
                }
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/modNormativa`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(objEdit)
                })
                const data = await res.json()
                const errorCode = data.error ?? data.status
                if(errorCode !== 0){
                    setModalErr(data.errorDetalle || data.codeError)
                } else {
                    handleClose()
                    // Actualizar normas
                    if(opc === 1){
                        fetchTemplates({user})
                    } else if (opc === 2) {
                        fetchTareas({
                            idProyecto: idProyectoNorma
                        })
                    } else if (opc === 3){
                        fetchSubtareas({
                            idtarea: objTareaSelec.id_tarea_norma
                        })
                    }
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            } finally {
                setLoading(false)
            }
        }
    }

    return (
        <Modal
            {...props}
            size='lg'
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modalNorma'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    <h3 className='m-0'>
                        {opc === 1 && "Editar norma"}
                        {opc === 2 && "Editar sección"}
                        {opc === 3 && "Editar subsección"}
                    </h3>
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form 
                    className='formNorma d-flex flex-column'
                    onSubmit={handleSubmit}
                >
                    {/* Título */}
                    <div className='mb-2'>
                        <label className='mb-1'>Título</label>
                        <textarea
                            onChange={handleChange}
                            id="titulo" 
                            name="titulo" 
                            autoFocus
                            rows="2"
                            className="form-control form-control-sm col-12"
                            value={obj.titulo}
                        />
                        {errors.titulo && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.titulo}</span>}
                    </div>
                    {/* Descripción */}
                    <div className='mb-2'>
                        <label className='mb-1'>Descripción</label>
                        <textarea
                            onChange={handleChange}
                            id="descripcion" 
                            name="descripcion"
                            rows="6"
                            className="form-control form-control-sm col-12"
                            value={obj.descripcion}
                        />
                        {errors.descripcion && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.descripcion}</span>}
                    </div>
                    {modalErr !== null && <span className='form__error text-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                    <button 
                        type='submit'
                        className='mt-2 px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                        disabled={loading}
                    >
                        {loading ? "Enviando..." : (
                            <>
                                {opc === 1 && "Editar norma"}
                                {opc === 2 && "Editar sección"}
                                {opc === 3 && "Editar subsección"}
                            </>
                        )}
                    </button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalEditarNorma